import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/Layout';
import { SearchProvider } from './lib/search/SearchProvider';
import { AuthProvider } from './lib/auth/AuthContext';

// Lazy load pages
const Home = React.lazy(() => import('./pages/Home'));
const Gallery = React.lazy(() => import('./pages/Gallery'));
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Cart = React.lazy(() => import('./pages/Cart'));
const Admin = React.lazy(() => import('./pages/admin'));

function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
        <SearchProvider>
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Layout />}>
                <Route
                  index
                  element={
                    <React.Suspense fallback={<div>Loading...</div>}>
                      <Home />
                    
                    </React.Suspense>
                  }
                />
                <Route
                  path="gallery"
                  element={
                    <React.Suspense fallback={<div>Loading...</div>}>
                      <Gallery />
                    
                    </React.Suspense>
                  }
                />
                <Route
                  path="about"
                  element={
                    <React.Suspense fallback={<div>Loading...</div>}>
                      <About />
                    
                    </React.Suspense>
                  }
                />
                <Route
                  path="contact"
                  element={
                    <React.Suspense fallback={<div>Loading...</div>}>
                      <Contact />
                    
                    </React.Suspense>
                  }
                />
                <Route
                  path="cart"
                  element={
                    <React.Suspense fallback={<div>Loading...</div>}>
                      <Cart />
                    
                    </React.Suspense>
                  }
                />
              </Route>

              {/* Admin routes */}
              <Route
                path="/admin/*"
                element={
                  <React.Suspense fallback={<div>Loading...</div>}>
                    <Admin />
                  
                  </React.Suspense>
                }
              />
            </Routes>
          </BrowserRouter>
        </SearchProvider>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;